import { ResolvedContactListPage } from "@/features/contact/pages/ResolvedContactList";
import React from "react";

const ResolvedContactList = () => {
  return <ResolvedContactListPage />;
};

export default ResolvedContactList;
